import { Injectable } from '@angular/core';
import * as polyline from '@mapbox/polyline';

declare var L: any;

const defaultCoords: number[] = [40, -80];
const defaultZoom: number = 8;
let map;

@Injectable()
export class MapService {
  constructor() {}

  setMap() {
    map = L.map('map').setView(defaultCoords, defaultZoom);
    map.maxZoom = 100;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors', layers : 'H'
    }).addTo(map);
    /*L.tileLayer('http://tiles.wmflabs.org/hillshading/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors', layers : 'H'
    }).addTo(map);*/
    /*L.tileLayer('https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);*/

    //https://wiki.openstreetmap.org/wiki/Tile_servers for other map options
  }

  plotGpx(file, callback) {
    map.remove();
    this.setMap();
    new L.GPX(file, { 
      async: true,
      polyline_options: {
        color: 'rgb(200,20,10)',
        opacity: 0.95,
        weight: 2,
        lineCap: 'round'
      },
      marker_options: {
        startIconUrl: 'assets/pin-icon-start.png',
        endIconUrl: 'assets/pin-icon-end.png',
        shadowUrl: 'assets/pin-shadow.png'
      }
    })
      .on('loaded', function(e) {
        map.fitBounds(e.target.getBounds());                
        console.log(e.target);
        callback((e.target.get_distance() / 1000).toFixed(2), e.target.get_elevation_gain(), e.target.get_elevation_loss());
      })
      .addTo(map);
  }

  addPolyLine(pl){    
    map.remove();
    this.setMap();
    var latlngs = polyline.decode(pl);
    var PolyLine = L.polyline(latlngs, {
      color: 'rgb(200,20,10)',
      weight : 2,
      opacity: 0.95,
      lineCap :'round'
    }).addTo(map);
    map.fitBounds(PolyLine.getBounds());    
  }
}
